import { render, staticRenderFns } from "./SchoolTableView.vue?vue&type=template&id=e5573c5c"
import script from "./SchoolTableView.vue?vue&type=script&lang=js"
export * from "./SchoolTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports